import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GameModeService } from '../../../_services/game-mode.service';
import { GameAudioService } from '../../../_services/game-audio.service';
import { GameQuestion } from '../../../interfaces/question.interface';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-quiz-result',
  templateUrl: './quiz-result.component.html',
  styleUrls: ['./quiz-result.component.scss']
})
export class QuizResultComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private autoAdvanceTimer: any = null;
  private resultAudio: HTMLAudioElement | null = null;

  question: GameQuestion | null = null;
  isCorrect = false;
  xpEarned = 0;
  currLang: any = 'en';

  constructor(
    private gameModeService: GameModeService,
    private globalService: GlobalService,
    private gameAudioService: GameAudioService
  ) {}

  ngOnInit(): void {
    this.gameModeService.currentQuestion$
      .pipe(takeUntil(this.destroy$))
      .subscribe(q => this.question = q);

    this.gameModeService.lastAnswerResult$
      .pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        if (result) {
          this.isCorrect = result.isCorrect;
          this.xpEarned = result.xpEarned;
          this.playResultSound(result.isCorrect);
        }
      });

    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);

    // Auto-advance to next question after 2s (matching mini-game behavior)
    this.autoAdvanceTimer = setTimeout(() => {
      this.nextQuestion();
    }, 2000);
  }

  ngOnDestroy(): void {
    if (this.autoAdvanceTimer) {
      clearTimeout(this.autoAdvanceTimer);
    }
    this.gameAudioService.stop(this.resultAudio);
    this.destroy$.next();
    this.destroy$.complete();
  }

  private playResultSound(correct: boolean): void {
    this.gameAudioService.stop(this.resultAudio);
    const file = correct ? 'correctSoundEffect.mp3' : 'buzzerSoundEffect.mp3';
    this.resultAudio = this.gameAudioService.play(`assets/game-mode/sound-effects/${file}`);
  }

  private arabicLabels: Record<string, string> = { 'A': 'أ', 'B': 'ب', 'C': 'ج', 'D': 'د' };

  getOptionLabel(id: string): string {
    return this.currLang === 'ar' ? (this.arabicLabels[id] || id) : id;
  }

  getCorrectAnswerText(): string {
    if (!this.question) return '';
    const correct = this.question.options.find(o => o.id === this.question.correctOptionId);
    if (!correct) return '';
    return this.currLang === 'ar' ? correct.text.ar : correct.text.en;
  }

  nextQuestion(): void {
    this.gameModeService.nextQuestion();
  }
}
